export default __webpack_public_path__ + "static/media/charging.add4073a.svg";